import PlansEntity from './index';
import SessionVersionsEntity from '../session-versions/index';
import ProductVersionsEntity from '../product-versions/index';

const sessionVersionIdsFromPlan = plan =>
    plan.planParts.flatMap(part => part.sessionBookings.map(booking => booking.sessionVersion));
const productVersionIdsFromPlan = plan =>
    plan.planParts.flatMap(part => part.productBookings.map(booking => booking.productVersion));

export const makeGetSessionsById = PlansEntity.selectors.makeRelationSelectorById(
    SessionVersionsEntity,
    sessionVersionIdsFromPlan,
);
export const makeGetProductsById = PlansEntity.selectors.makeRelationSelectorById(
    ProductVersionsEntity,
    productVersionIdsFromPlan,
);

export const getSessionsById = makeGetSessionsById();
export const getProductsById = makeGetProductsById();
